/**
 * Search Modal Component
 *
 */
class SearchModal extends HTMLElement {
  constructor() {
    super();

    let _this = this;
    this.openSearchModal = document.querySelectorAll('.open-searchform');
    this.searchFormContainer = this.querySelector('.searchform');

    this.searchFormContainer.addEventListener('keyup', (event) => {
      if(event.code && event.code.toUpperCase() === 'ESCAPE') this.close();
    });

    this.openSearchModal.forEach(toggleBtn =>{
      toggleBtn.addEventListener('click', function(event){
        event.preventDefault();
        _this.onToggleBtnClick(event);
      });
      toggleBtn.setAttribute('role', 'button');
      toggleBtn.setAttribute('aria-expanded', 'false');
    });
    if(this.querySelector('.search-close')){
      this.querySelector('.search-close').addEventListener('click', this.close.bind(this));
    }
  }

  /**
   * To check if search modal is open or closed
   * 
   * @returns {boolean} true/false
   */
  isOpen() {
    return this.searchFormContainer.hasAttribute('open');
  }

  /**
   * Toggle Search Modal on search Icon click
   *
   * @param {event} Event instance
   */
  onToggleBtnClick(event) {
    event.preventDefault();
    event.stopPropagation();
    // Nav redesign Oct 2026: remember the opener so focus can return to it on close
    this.activeToggle = event.currentTarget;
    this.searchFormContainer.hasAttribute('open')
      ? this.close()
      : this.open(event);
  }

  /**
   * Open Search Modal and add attributes, class and Events in DOM
   *
   * @param {event} Event instance
   */
  open(_event) {
    // Nav redesign Oct 2026: close the drawer / cart FIRST so their close handlers can't undo the
    // overlay + scroll lock set below (search can now be opened from inside the mobile drawer)
    if(document.querySelector('.mobile-nav-drawer').classList.contains('opened-drawer')){
      document.querySelector('.close-mobile--navbar').dispatchEvent(new Event('click'));
    }
    if(document.querySelector('cart-form.cart-drawer').classList.contains('opened-drawer')){
      document.querySelector('.close-ajax--cart').dispatchEvent(new Event('click'));
    }
    document.body.classList.add('search-open');
    this.searchFormContainer.setAttribute('open', true);
    this.classList.add('open__modal');
    this.querySelector('.search-input').removeAttribute('disabled');
    if(siteOverlay) siteOverlay.prototype.showOverlay();
    // W8a: place the modal and overlay under the header as it is now (scroll lock applied above)
    updateHeaderBottom();
    this.setToggleExpanded(true);

    Utility.trapFocus(this);
    Utility.forceFocus(document.getElementById('Search-In-Modal'));
  }

  /**              
   * Close Search Modal and remove attributes, class and Events in DOM
   *
   * @param {event} Event instance
   */
  close(_focusToggle = true) {
    document.body.classList.remove('search-open');
    Utility.removeTrapFocus();
    this.searchFormContainer.removeAttribute('open');
    this.classList.remove('open__modal');
    siteOverlay.prototype.hideOverlay();

    // Nav redesign Oct 2026: sync aria-expanded and return focus to the opener (not on scroll-close, which passes false)
    this.setToggleExpanded(false);
    // If search was opened from the (now closed) mobile drawer, return focus to the hamburger instead
    let focusTarget = this.activeToggle;
    if (focusTarget && focusTarget.closest('#mobile-menu-drawer')) {
      focusTarget = document.getElementById('mobile-menu');
    }
    if (_focusToggle && focusTarget && typeof focusTarget.focus === 'function') {
      focusTarget.focus();
    }
    this.activeToggle = null;
  }

  /**
   * Set aria-expanded on all search toggles
   *
   * @param {boolean} expanded
   */
  setToggleExpanded(expanded) {
    this.openSearchModal.forEach(toggleBtn => toggleBtn.setAttribute('aria-expanded', expanded ? 'true' : 'false'));
  }
}
customElements.define('search-modal', SearchModal);